import {useCallback, useEffect} from "react"
import {throttle} from "lodash"

export function useOnScrollToBottom<T>({
  onNewPage,
  scrollThreshold = 100,
  throttleMs = 100
}: {
  scrollThreshold?: number
  throttleMs?: number
  onNewPage: () => Promise<T> | null
}) {
  const onScrollHandler = useCallback(() => {
    const tolerance = scrollThreshold
    const windowHeight = window.innerHeight
    const documentHeight = document.documentElement.scrollHeight
    const scrollY = window.scrollY

    // Check if user has scrolled to within tolerance pixels of the bottom
    const isNearBottom = scrollY + windowHeight >= documentHeight - tolerance

    if (isNearBottom) {
      onNewPage()
    }
  }, [onNewPage, scrollThreshold])

  // Add a window scroll observer to detect the page scrollY
  useEffect(() => {
    const throttledOnScrollHandler = throttle(onScrollHandler, throttleMs)
    // call once in case we are already at the bottom
    throttledOnScrollHandler()
    window.addEventListener("scroll", throttledOnScrollHandler)

    return () => {
      window.removeEventListener("scroll", throttledOnScrollHandler)
    }
  }, [onScrollHandler, throttleMs])
}
